import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';
import {viewFourDrop, viewFourRemoveStep} from '@learningblocks/exp-redux';

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onDropStep: (params) => dispatch(viewFourDrop(params)),
    onRemoveStep: (params) => dispatch(viewFourRemoveStep(params)),
  };
}

export const GroupA = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.GroupA);
